'use client';

import React from 'react';
import { formatDayAbbr } from 'src/utils/formatDayAbbr/formatDayAbbr';

const getDayCircleClasses = (pct: number) => {
  if (pct === 0) return 'bg-slate-200 text-neutral-400';
  if (pct <= 20) return 'bg-green-100 text-green-800';
  if (pct <= 40) return 'bg-green-500 text-green-100';
  if (pct <= 60) return 'bg-green-700 text-green-200';
  return 'bg-green-800 text-green-100';
};

interface ScheduleDayCirclesProps {
  schedule: Record<string, { percentage?: number; claims?: number }>;
  'data-testid'?: string;
}

const ScheduleDayCircles: React.FC<ScheduleDayCirclesProps> = ({
  schedule,
  'data-testid': testId,
}) => (
  <div
    className="flex items-center justify-between"
    data-testid={testId}
  >
    {Object.entries(schedule).map(([day, dayData]) => {
      const pct = dayData?.percentage ?? 0;
      return (
        <div key={day} className="flex flex-col items-center gap-0.5">
          <div
            className={`flex items-center justify-center w-8 h-8 rounded-full text-xs font-medium ${getDayCircleClasses(pct)}`}
            title={`${formatDayAbbr(day)}: ${pct}%`}
          >
            {formatDayAbbr(day)}
          </div>
          <span className="text-xs text-neutral-600 tabular-nums">
            {pct}%
          </span>
        </div>
      );
    })}
  </div>
);

export default ScheduleDayCircles;
